export default "__VITE_ASSET__DwaVCGsF__"